<div
  role="alert"
  [class]="'alert-' + style"
  [ngClass]="{'alert-container-sm': small,
     'alert-container' : displayedText || confirmationLabel || small || contentTpl,
      'ob1-alert-row' : alertRow}"
  [attr.data-e2e]="e2e"
>
  <ng-container *ngIf="alertRow">
    <div class="d-flex flex-column">
      <ng-container [ngTemplateOutlet]="alertHeader"></ng-container>
      <div class="alert-content">
        <ng-container [ngTemplateOutlet]="alertContent"></ng-container>
      </div>
    </div>
    <div class="alert-content">
      <ng-container [ngTemplateOutlet]="alertConfirm"></ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="!alertRow">
    <ng-container [ngTemplateOutlet]="alertHeader"></ng-container>
    <div *ngIf="(displayedText || confirmationLabel) && !contentTpl; else customText" class="alert-content">
      <ng-container [ngTemplateOutlet]="alertContent"></ng-container>
      <ng-container [ngTemplateOutlet]="alertConfirm"></ng-container>
    </div>
  </ng-container>
</div>

<ng-template #alertHeader>
  <p class="alert" [ngClass]="{'ob1-alert-normal' : alertNormal && !confirmationLabel}">
    <span class="alert-icon" [ngClass]="MaterialAlertIconClass[style]" aria-hidden="true"></span>
    <span class="ob1-alert-title" [attr.data-e2e]="e2e + '-title'">{{title}}</span>
  </p>
</ng-template>

<ng-template #alertContent>
  <p *ngFor="let item of displayedText" [ngClass]="{'alert-text' : !alertRow}">{{item}}</p>
</ng-template>

<ng-template #alertConfirm>
  <!-- alert confirmation -->
  <ng-container *ngIf="confirmationLabel">
    <!-- link confirmation style -->
    <ng-container *ngIf="isLinkConfirmationTemplate; else confirmationButtonTemplate">
      <a
        [attr.data-e2e]="e2e + '-confirmation'"
        [ecmDisabledAction]="isDisabledEclair"
        [href]="confirmationPath || ''"
        [ngClass]="{
                        'btn btn-secondary': confirmationStyle === 'button',
                        'o-link-arrow ob1-link-dark text-mw': confirmationStyle === 'link',
                        'o-link-small': small
                        }"
        (click)="materialAlertConfirm(); false"
      >
        {{confirmationLabel}}
      </a>
    </ng-container>

    <!-- button confirmation style -->
    <ng-template #confirmationButtonTemplate>
      <button
        class="btn btn-secondary"
        type="button"
        (click)="materialAlertConfirm()"
        [attr.data-e2e]="e2e + '-confirmation'"
        [ecmDisabledAction]="isDisabledEclair"
      >
        {{confirmationLabel}}
      </button>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #customText>
  <div *ngIf="contentTpl" [attr.data-e2e]="e2e + '-body'" class="alert-content">
    <ng-content></ng-content>
  </div>
</ng-template>
